import api from "../../api.js";

/**
 * Order voucher service
 * (i.e. issued vouchers)
 *
 * @package HOPS
 * @subpackage Orders
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class OrderVoucherService {

	/**
	 * Get a voucher's details by its code.
	 *
	 * @param {String} code
	 * @return {Promise}
	 */
	static getVoucherDetails(code) {
		return api.call({url: `/api/checkout/ovouchers/${code}`}).then(({data}) => data);
	}


	/**
	 * Get the display string for a voucher code.
	 *
	 * @param {String} code
	 * @return {String}
	 */
	static getVoucherCodeDisplayString(code) {
		return code.match(/.{1,4}/g).join("-");
	}


	/**
	 * Transform a user's voucher code input for display purposes.
	 *
	 * Inserts display hyphens and converts to uppercase.
	 *
	 * @param {String|null} code
	 * @param {String|null} currentInputValue Used to disable hyphens on backspace
	 * @return {String|null}
	 */
	static transformVoucherCodeInput(code, currentInputValue) {

		const indexes = [4, 9, 14];

		if (!code) {
			return null;
		}
		else if (indexes.includes(code.length) && (code.length > currentInputValue.length)) {
			code += "-";
		}
		else if (indexes.map(i => (i + 1)).includes(code.length) && !code.endsWith("-")) {
			const last = code[(code.length - 1)];
			code = `${code.substring(0, (code.length - 1))}-${last}`;
		}

		return code.toUpperCase();

	}


	/**
	 * Transform a user's voucher code input to a code value 
	 * understood by the API. Removes display hyphens when present 
	 * and maps `1` to `I` and `0` to `O` to avoid ambiguities.
	 *
	 * @param {String} code
	 * @return {String}
	 */
	static transformVoucherCodeInputToApiCode(code) {
		return code.replaceAll("-", "").replaceAll("1", "I").replaceAll("0", "O").toUpperCase();
	}

}

export default OrderVoucherService;
